/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для блока с количеством и кнопкой "Купить" для услуги в списке товаров
   */
  app.ServiceCategoryItemQtyView = app.ServiceItemQtyView.extend({
    el: '.btn-block',
    
    run: function (options) {
      app.ServiceItemQtyView.prototype.run.apply(this, arguments);
      if (options) {
        if (options.collection) {
          this.collection = options.collection;
        }
      }
      var templateSelector = '.btn-service-template';
      if (this.collection.viewtype === 'cards') {
        templateSelector = '.btn-service-cards-template';
      }
      if (this.collection.viewtype === 'xxl') {
        templateSelector = '.btn-service-xxl-template';
      }
      this.btn_template = app.helpers.TemplateHelper.getTemplate(templateSelector);
      this.wtfId = this.item.get('id');
      this.price = this.item.get('price');
      this.minimum = this.item.get('minQty');
      this.maximum = this._initMaximum();
      this.value = this.model.get('qty');
      this.addCartItemToCart();
    },
  
    /**
     * Рендерит блок цены
     */
    render: function (options) {
      options = options ? options : {controls: [false, false]};
      if (!((this.item.get('isEnough') === false && this.item.get('balance') === 0))) {
        this.$el.html(this.btn_template({
          model: this.item.toJSON(),
          cartItem: this.model.toJSON(),
          qtyRule: this.getQtyRule(),
          qty: this.model.get('qty')
        }));
        this.initDom();
        this.updateControls.apply(this, options.controls);
      } else if (this.item.get('is_gift') || this.collection.viewtype !== 'list' || app.isMobile) {
        this.$el.html('');
      } else {
        this.$el.html('<div class="catalog__item-not-in-stock"><span>Нет в наличии</span></div>');
      }
    },
    /**
     * Необходимо, чтобы не сдвигался тултип "Добавлено в корзину"
     * в категориях
     */
    calculateHeaderPosition: function () {
      return 0;
    }
  });
})(jQuery);

}.call(window));